import type { AppRouteRecord } from '../types';
import { ROUTE_NAMES, ROUTE_PATHS } from '../constants';

// TODO: Replace DashboardPage with actual page components when implemented
export const placeholderRoutes: AppRouteRecord[] = [
  {
    path: ROUTE_PATHS.TIMESHEET,
    name: ROUTE_NAMES.TIMESHEET,
    component: () => import('@/pages/DashboardPage.vue'),
  },
];
